import Repository from './Repository.js';

class ActionsRepository extends Repository {
    async getActions(query) {
        return await this.get('actions', query);
    }
}

export default new ActionsRepository();
